import { gql } from '@apollo/client'

export const PLACE_TRANSFER_OFFER = gql`
  mutation PlaceTransferOffer($fantasyLeagueId: ID!, $playerId: ID!, $amount: Int!) {
    placeTransferOffer(input: { fantasyLeagueId: $fantasyLeagueId, playerId: $playerId, amount: $amount }) {
      transferOffer {
        id
        amount
        status
        createdAt
        player {
          id
          nick
        }
        bidder {
          id
          teamName
        }
        seller {
          id
          teamName
        }
      }
      errors
    }
  }
`

export const UPDATE_TRANSFER_OFFER_STATUS = gql`
  mutation UpdateTransferOfferStatus($transferOfferId: ID!, $newStatus: String!) {
    updateTransferOfferStatus(input: { transferOfferId: $transferOfferId, newStatus: $newStatus }) {
      transferOffer {
        id
        status
        amount
        player {
          id
          nick
        }
      }
      errors
    }
  }
`

export const WITHDRAW_TRANSFER_OFFER = gql`
  mutation WithdrawTransferOffer($transferOfferId: ID!) {
    withdrawTransferOffer(input: { transferOfferId: $transferOfferId }) {
      transferOffer {
        id
        status
      }
      errors
    }
  }
`
